<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1" tab="数据看板">
        <index-tab type="active"></index-tab>
      </a-tab-pane>
      <a-tab-pane key="2" tab="做单数据">
        <post-tab type="active"></post-tab>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import moment from "moment";
import Api from "@/api";
import baseComponentVue from "@/components/base-component.vue";
import IndexTab from "./components/index-tab";
import PostTab from "./components/post-tab";
export default {
  name: "hunter-activation",
  extends: baseComponentVue,
  data() {
    return {
      tabs: Object.freeze([
        { label: "数据看板", value: "dashboard" },
        { label: "做单数据", value: "postData" }
      ]),
      tab: "dashboard",
      loading: false,
      dataSource: [],
      columns: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      params: {
        tabs: this.$route.query.tab || ""
      }
    };
  },
  components: { IndexTab, PostTab },
  created() {
    this.resetParams();
    this.setColums();
    this.getData();
  },
  methods: {
    tabChange(value) {
      this.$router.replace({ path: "/cash/job", query: { tab: value } });
      this.getData();
    },
    rowClick(record) {
      return {
        on: {
          click: () => {
            this.$refs.markDetailModal.show(record);
          }
        }
      };
    },
    setColums() {
      this.columns = [
        {
          title: "ID",
          dataIndex: "id"
        },
        {
          title: "招聘负责人",
          dataIndex: "contact_name",
          scopedSlots: { customRender: "contact" }
        },
        {
          title: "招聘公司",
          dataIndex: "company_name"
        },
        {
          title: "附言",
          dataIndex: "note",
          width: 200
        },
        {
          title: "推荐人",
          width: 200,
          dataIndex: "post_user.name",
          scopedSlots: { customRender: "recommend" }
        },
        {
          align: "center",
          title: "公开身份",
          dataIndex: "is_public",
          scopedSlots: { customRender: "is_public" }
        },
        {
          title: "最近状态更新时间",
          dataIndex: "updated_at"
        },
        {
          title: "状态",
          dataIndex: "status",
          customRender(text, record) {
            let t = "";
            switch (text) {
              case "CREATE":
                t = "新推变现";
                break;
              case "SUCCESS":
                t = "已获取职位";
                break;
              case "FAILED":
                t = "未获取职位";
                break;
              case "COMMUNICATE":
                t = "沟通中";
                break;
              case "PUBLISH_JOB":
                t = "已发布";
                break;
            }
            return t;
          }
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" }
        }
      ];
    },
    async getData(pagination, filters, sorter) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        // this.pagination.current = 1;
      }

      // let params = {
      //   [this.params.main]: this.params.mainValue,
      //   created_start:
      //     this.params.time[0] &&
      //     this.params.time[0].format("YYYY-MM-DD HH:mm:ss"),
      //   created_end:
      //     this.params.time[1] &&
      //     this.params.time[1].format("YYYY-MM-DD HH:mm:ss"),
      //   statuses: this.params.tabs,
      //   page: this.pagination.current,
      //   limit: this.pagination.pageSize
      // };

      // let response = await Api.cash.getJobList(params);
      this.loading = false;
      // this.pagination.total = +response.total;
      // this.dataSource = response.list;
    },
    resetParams() {
      let params = {
        time: [],
        main: "company_name",
        mainValue: ""
      };
      this.params = { tabs: this.params.tabs, ...params };
    },
    async checkStatus(item, body, type) {
      try {
        await Api.cash.checkJobStatus({
          type,
          body,
          job_clue_id: item.id
        });
        this.$refs.markModal.close();
        this.getData();
      } catch (e) {
        this.$refs.markModal.distubeLoading();
      }
    },
    addJob(record) {
      this.$router.push({
        path: "/post-edit",
        query: {
          id: record.id
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
